const LOW_BATTERY = 38;

const AUTH_TYPE_OPTIONS = [
    { id: 'None', label: 'None' },
    { id: 'RFID', label: 'RFID' },
];

const RESET_TYPES = {
    SOFT: 'Soft',
    HARD: 'Hard',
} as const;

const CONNECTOR_STATUS = {
    AVAILABLE: 'Available',
    PREPARING: 'Preparing',
    CHARGING: 'Charging',
    SUSPENDED_EVSE: 'SuspendedEVSE',
    SUSPENDED_EV: 'SuspendedEV',
    FINISHING: 'Finishing',
    RESERVED: 'Reserved',
    UNAVAILABLE: 'Unavailble',
    FAULTED: 'Faulted',
} as const;

const MISSION_STATUS = {
    ONGOING: 'Ongoing',
    COMPLETED: 'Completed',
    ISSUE: 'Issue',
    PLANNED: 'Planned',
} as const;

const MANUAL_CONTROL_STATUS = {
    STARTED: 'STARTED',
    STOPPED: 'STOPPED',
} as const;

const STATION_STATUS = {
    OFFLINE: 'Offline',
    AVAILABLE: 'Available',
} as const;

const MISSION_STATUS_ORDER = {
    Completed: 1,
    Planned: 2,
    Ongoing: 3,
    Issue: 4,
} as const;

export {
    LOW_BATTERY,
    CONNECTOR_STATUS,
    MANUAL_CONTROL_STATUS,
    RESET_TYPES,
    AUTH_TYPE_OPTIONS,
    MISSION_STATUS,
    STATION_STATUS,
    MISSION_STATUS_ORDER,
};
